import { createActions } from 'redux-actions';
var prefix = 'APP';
var actionTypes = ['TOGGLE_DRAWER', 'SET_ONLINE', 'SET_OFFLINE', 'TOGGLE_SEARCH', 'EXECUTE_SEARCH', 'MARK_ERROR_HANDLED', 'SET_PAGE_LOADING', 'SET_NEXT_ROOT_COMPONENT'];
export default createActions.apply(void 0, actionTypes.concat([{
  prefix: prefix
}]));